import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  UntypedFormBuilder,
} from "@angular/forms";
import { UserserviceService } from "src/app/Services/userservice.service";
import { ToastrService } from "ngx-toastr";
import { Endpoint } from "src/app/shared/endpoints";
import { AuthModalService } from "src/app/Services/auth-modal.service";

@Component({
  selector: "app-forget-password-modal",
  templateUrl: "./forget-password-modal.component.html",
  styleUrls: ["./forget-password-modal.component.scss"],
})
export class ForgetPasswordModalComponent implements OnInit {
  EmailAddress: string;
  noResultReturned: boolean;
  showMessage: boolean;

  @Output() closeModal = new EventEmitter<void>();

  constructor(
    public formbuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private userserviceService: UserserviceService,
    public authModalService: AuthModalService
  ) {}

  forgetPasswordForm = new UntypedFormGroup({
    EmailAddress: new UntypedFormControl("", [Validators.required, Validators.email]),
  });

  ngOnInit(): void {
    this.forgetPasswordForm = this.formbuilder.group({
      EmailAddress: new UntypedFormControl("", [
        Validators.required,
        Validators.email,
      ]),
    });
  }

  submit() {
    if (!this.EmailAddress) {
      this.showMessage = true;
      this.toastr.warning("Add email address to get activation code.");
      return;
    }

    if (this.forgetPasswordForm.invalid) {
      this.forgetPasswordForm.markAllAsTouched();
      return;
    }

    this.noResultReturned = true;
    const loginModel = {
      UserEmail: this.EmailAddress.trim(),
    };

    // Wait for email existence check before sending the reset code
    this.userserviceService.checkUserWithEmailAddressExists(loginModel).subscribe({
      next: (exists) => {
        if (!exists) {
          this.noResultReturned = false;
          this.showMessage = true;
          this.toastr.warning(
            "Email address does not exist. Please sign up to continue."
          );
          return;
        }

        this.userserviceService
          .changeOldPassword(Endpoint.forgetPassword, loginModel)
          .subscribe({
            next: (sent) => {
              this.noResultReturned = false;
              if (sent) {
                this.showMessage = false;
                this.toastr.success("Activation Code Sent Successfully");
                localStorage.setItem(
                  "userEmail",
                  JSON.stringify(this.EmailAddress.trim())
                );
                this.authModalService.openModal("change-password");
              } else {
                this.toastr.error(
                  "Unable to send reset code. Please try again."
                );
              }
            },
            error: () => {
              this.noResultReturned = false;
              this.toastr.error(
                "Unable to send reset code. Please try again."
              );
            },
          });
      },
      error: () => {
        this.noResultReturned = false;
        this.toastr.error("Unable to verify email. Please try again.");
      },
    });
  }
}
